import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=1cd03223&scoped=true"
import script from "./ProcessForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProcessForm.vue?vue&type=style&index=0&id=1cd03223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd03223",
  null
  
)

export default component.exports